var React = require('react');

function Projects (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.889325 0.00555376L35.7227 19.9721L20.9665 45.3613L0.889325 0.00555376Z","fill":"#FECD8B","key":0}),React.createElement("path",{"d":"M20.9662 45.3561L35.7223 19.9668L70.5557 39.9425L35.7223 59.9183L0.889 79.8848L20.9662 45.3561Z","fill":"#FEEACE","key":1}),React.createElement("path",{"d":"M20.9658 45.3561L0.888599 79.8848L0.8886 39.9425L0.8886 0.000304923L20.9658 45.3561Z","fill":"#FDAB3D","key":2})]);
}

Projects.defaultProps = {"width":"71","height":"80","viewBox":"0 0 71 80","fill":"none"};

module.exports = Projects;

Projects.default = Projects;
